
import { GenericEntityMetadata, PropertyMetadata, nullIfContainsNull } from '@scisys-uim/uim-common';


export class ElectricalAspectMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('ElectricalAspect', {
      aspectAssetId: <PropertyMetadata> {
        name: 'aspectAssetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      portableApplianceTestingDays: <PropertyMetadata> {
        name: 'portableApplianceTestingDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.aspectAssetId;
    return nullIfContainsNull(result);
  }
}



